export const MODIFIER_TYPES = {
  DEFAULT: 'DEFAULT',
  WIN: 'WIN',
  LOSS: 'LOSS',
  DRAW: 'DRAW'
}
export const MODIFIER_VALUE = {
  DEFAULT: 1.3,
  WIN: 1.5,
  LOSS: 1.01,
  DRAW: 1.1
}

export const MODIFIERS = {
  [MODIFIER_TYPES.DEFAULT]: {
    followers: 200,
    popularity: MODIFIER_VALUE.DEFAULT,
    charisma: MODIFIER_VALUE.DEFAULT,
    streak: MODIFIER_VALUE.DEFAULT,
    damage: MODIFIER_VALUE.DEFAULT,
    stamina: MODIFIER_VALUE.DEFAULT,
    morale: MODIFIER_VALUE.DEFAULT
  },
  [MODIFIER_TYPES.WIN]: {
    followers: 2000,
    popularity: MODIFIER_VALUE.WIN,
    charisma: MODIFIER_VALUE.WIN,
    damage: MODIFIER_VALUE.WIN,
    streak: MODIFIER_VALUE.WIN,
    stamina: MODIFIER_VALUE.WIN,
    morale: MODIFIER_VALUE.WIN
  },
  [MODIFIER_TYPES.LOSS]: {
    followers: 500,
    popularity: MODIFIER_VALUE.LOSS,
    damage: MODIFIER_VALUE.LOSS,
    charisma: MODIFIER_VALUE.LOSS,
    stamina: MODIFIER_VALUE.LOSS,
    morale: MODIFIER_VALUE.LOSS
  },
  [MODIFIER_TYPES.DRAW]: {
    followers: 750,
    popularity: MODIFIER_VALUE.DRAW,
    charisma: MODIFIER_VALUE.DRAW,
    damage: MODIFIER_VALUE.DRAW,
    streak: MODIFIER_VALUE.DRAW,
    stamina: MODIFIER_VALUE.DRAW,
    morale: MODIFIER_VALUE.DRAW
  }
}
